module.exports = __webpack_public_path__ + "img/gratuity-level-3.6befe82d.png";